module.exports = __webpack_public_path__ + "img/productHome3.5bd40914.png";